interface MobileSectionDividerProps {
  title: string;
}

/**
 * Bold section divider — CNBC / Bloomberg style.
 * Creates visual "chapters" in the feed so users can
 * skip to areas of interest.
 */
export function MobileSectionDivider({ title }: MobileSectionDividerProps) {
  return (
    <div className="flex items-center gap-3 pt-2">
      <h4
        className="font-bold text-[0.82rem] text-[var(--explore-text-primary)] uppercase tracking-[0.06em]"
        style={{ fontFamily: "var(--explore-card-title-stack)" }}
      >
        {title}
      </h4>
      <div className="h-px flex-1 bg-[var(--explore-border)]" />
    </div>
  );
}
